import matrix from ".././assets/images/matrix.jpeg";
import { ProductCard } from "../components";

import { Link } from "react-router-dom";

function Main(props) {
  return (
    <section className="main">
      <img src={matrix} alt="hero" className="main__hero" />
      <section className="main__content">
        <h2 className="main__title">FEATURED COLLECTION</h2>

        <section className="main__cards fadeInUp">
          {props.productInfo.map((product, index) => {
            return (
              <Link
                to={`/product/${product.id}`}
                key={index}
                onClick={() => props.pageReset()}
              >
                <ProductCard
                  product={product}
                  addToCart={props.addToCart}
                  handleProductClick={props.handleProductClick}
                />
              </Link>
            );
          })}
        </section>
      </section>
    </section>
  );
}

export default Main;
